import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import BreadCrumbList from './BreadCrumbList';
import BreadcrumbsPortal from '../BreadcrumbsPortal';
const GeneralBreadcrumb = _ref => {
  let {
    claimGroup,
    items
  } = _ref;
  return /*#__PURE__*/React.createElement(BreadcrumbsPortal, null, /*#__PURE__*/React.createElement(Breadcrumb, null, /*#__PURE__*/React.createElement(BreadCrumbList, {
    claimGroup: claimGroup,
    items: items
  })));
};
export default GeneralBreadcrumb;